import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  fullWidth?: boolean;
  loading?: boolean;
  icon?: React.ReactNode;
}
export function Button({
  children,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  loading = false,
  icon,
  className = '',
  disabled,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-xl font-semibold transition-all duration-200 active:scale-[0.98]';
  const variants = {
    primary: 'bg-primary text-white hover:bg-primary-600 shadow-sm',
    secondary: 'bg-secondary text-white hover:bg-primary-800 shadow-sm',
    outline: 'border-2 border-gray-200 text-gray-800 hover:border-primary hover:text-primary bg-transparent',
    ghost: 'bg-transparent text-gray-600 hover:bg-gray-100'
  };
  const sizes = {
    sm: 'px-3 py-1.5 text-sm',
    md: 'px-4 py-3 text-base',
    lg: 'px-6 py-4 text-lg'
  };
  return <button className={`
        ${baseStyles}
        ${variants[variant]}
        ${sizes[size]}
        ${fullWidth ? 'w-full' : ''}
        ${disabled || loading ? 'opacity-60 cursor-not-allowed active:scale-100' : ''}
        ${className}
      `} disabled={disabled || loading} {...props} data-id="element-101">
      {loading ? <Loader2 className="w-5 h-5 mr-2 animate-spin" data-id="element-102" /> : icon ? <span className="mr-2" data-id="element-103">{icon}</span> : null}
      {children}
    </button>;
}